<div class="modal-pareceres-emitidos">
    <div class="modal-pareceres-emitidos-header">
        <h5>Outros pareceres emitidos na análise</h5>
        <div class="modal-pareceres-emitidos-header-close">
            <a (click)="fecharModal()">X</a>
        </div>
    </div>
    <div *ngFor="let etapa of pareceresAnalise.pareceres" class="modal-pareceres-emitidos-etapa">
        <p class="modal-pareceres-emitidos-etapa-nome">{{etapa.nomeEtapa}}</p>

        <div *ngIf="etapa.pareceresDisponiveis == 0">
            <pre style="text-align: center;">
            NÃO FORAM ENVIADOS DOCUMENTOS PELO SERVIÇO
            </pre>
        </div>
        <div class="modal-pareceres-emitidos-etapa-parecer" *ngIf="etapa.pareceresDisponiveis.length !== 0">


            <ng-template [ngIf]="etapa.pareceresDisponiveis.parecer.length > 1">
                <div *ngFor="let parecer of etapa.pareceresDisponiveis.parecer; index as i" class="linha-parecer-emitido">
                    <span class="modal-pareceres-emitidos-etapa-parecer-tipo">{{parecer.tipoParecer}}
                    </span>
                    <a class="btn btn-default" (click)="downloadParecerAnalise(parecer.idDocumento)">Download
                    </a>
                </div>
            </ng-template>
            <ng-template [ngIf]="etapa.pareceresDisponiveis.parecer.hasOwnProperty('idDocumento') ">
                <div class="linha-parecer-emitido">
                    <span class="modal-pareceres-emitidos-etapa-parecer-tipo">{{etapa.pareceresDisponiveis.parecer.tipoParecer}}
                    </span>
                    <a class="btn btn-default" (click)="downloadParecerAnalise(etapa.pareceresDisponiveis.parecer.idDocumento)">Download
                    </a>
                </div>
            </ng-template>

            <!-- <span
                class="modal-pareceres-emitidos-etapa-parecer-tipo">{{etapa.pareceresDisponiveis.parecer.tipoParecer}}</span> -->
            <!-- -
            <span class="modal-pareceres-emitidos-etapa-parecer-nota">{{etapa.pareceresDisponiveis.parecer.nota}}</span> -->
            <!-- <a class="btn btn-default"
                (click)="downloadParecerAnalise(etapa.pareceresDisponiveis.parecer.idDocumento)">Download
            </a> -->
        </div>
    </div>
</div>